const moment = require("moment");
const _ = require("lodash");
const {FLAGS} = require("../../core/util/GlobalFlags");
const LabUtil = require("../../../shared/LabUtil");
const labJson = require("../../../shared/data/dbLab.json");
const RuntimeTrainerData = require("../../../shared/RuntimeTrainerData");

const {
	atUser,
	atLabBlock,
	atLabType,
	atLabTypes,
	atAllLabTypes,
} = require("../../core/vault/StateCursors");
const UnlockUtil = require("../../core/util/UnlockUtil");

const WEEKS_AS_NEW = 6; // Number of weeks that lab types/blocks counted as new

// Should this lab type have a "New!" label.
const isConsideredNew = function(releasedAt) {
	if (!releasedAt) {
		return false;
	}
	return (
		moment(releasedAt).isAfter(moment().subtract(WEEKS_AS_NEW, "w")) &&
		moment(releasedAt).isAfter(moment("2020-04-15"))
	);
};

const getAllTypeIDs = function() {
	let allTypeIDs;
	if (FLAGS.accessUnderConstructionLabTypes) {
		allTypeIDs = labJson.puzzleTypes.map(p => p.id);
	} else {
		allTypeIDs = _.map(
			_.filter(labJson.puzzleTypes, p => !p.underConstruction),
			pi => pi.id
		);
	}
	return allTypeIDs;
};

const getAllTypes = function() {
	if (FLAGS.accessUnderConstructionLabTypes) {
		return labJson.puzzleTypes;
	} else {
		return _.filter(labJson.puzzleTypes, p => !p.underConstruction);
	}
};

const getCelestialFromHash = function(hash) {
	return _.find(labJson.celestials, c => c.hash === hash);
};

const getOrderForTypeID = function(typeID) {
	return _.findIndex(getAllTypes(), p => p.id === typeID);
};

const unlockOnLeveling = function(newState, newLevel) {
	// Progress Unlock spaces
	// TODO: only deal with lab space for now
	const spacesUnlocked = UnlockUtil.getAllUnlockedTypes("spaces", newLevel);
	if (_.includes(spacesUnlocked, "lab")) {
		const typeIDs = _.keys(atLabTypes(newState).get());
		_.each(typeIDs, tid => {
			if (
				atLabType(newState, tid).getIn(["model", "spaceLockType"]) ===
				"progress"
			) {
				if (!atLabType(newState, tid).getIn(["model", "spaceUnlocked"])) {
					newState = atLabType(newState, tid).setIn(
						["model", "spaceUnlocked"],
						true
					);
				}
			}
		});
		if (!atUser(newState).getIn(["model", "labProgressUnlocked"])) {
			newState = atUser(newState).setIn(["model", "labProgressUnlocked"], true);
		}
	}

	// Progress unlock lab types and lab blocks with celestialID = 1
	// Need to update in a few places in the vault: labTypes, labBlocks, allLabTypes
	const labTypesUnlocked = UnlockUtil.getAllUnlockedTypes(
		"puzzleTypes",
		newLevel
	);
	_.each(labTypesUnlocked, typeID => {
		const labModel = atLabType(newState, typeID).getIn("model");
		const typeIndex = getOrderForTypeID(typeID);
		// Only do unlocking if the type wasn't manually unlocked or locked
		if (labModel && labModel.lockType === "progress" && !labModel.unlocked) {
			const labBlockIDs = labModel.blockIDs;
			newState = atLabType(newState, typeID).setIn(["model", "unlocked"], true);

			_.each(labBlockIDs, (bid, i) => {
				const blockModel = atLabBlock(newState, bid).getIn("model");
				if (
					blockModel &&
					blockModel.celestialID === 1 &&
					!blockModel.lockOverride &&
					!blockModel.unlocked
				) {
					newState = atLabBlock(newState, bid).setIn(
						["model", "unlocked"],
						true
					);
				}
				const blockInfo = atAllLabTypes(newState).getIn([
					"typeInfo",
					typeIndex,
					"blockData",
					i,
				]);
				if (
					blockInfo &&
					blockInfo.lockType === "progress" &&
					!blockInfo.unlocked
				) {
					newState = atAllLabTypes(newState).setIn([
						"typeInfo",
						typeIndex,
						"blockData",
						i,
						"unlocked",
					]);
				}
			});
		}
		const typeInfo = atAllLabTypes(newState).getIn(["typeInfo", typeIndex]);
		if (typeInfo && typeInfo.lockType === "progress" && !typeInfo.unlocked) {
			newState = atAllLabTypes(newState).setIn(
				["typeInfo", typeIndex, "unlocked"],
				true
			);
		}
	});

	return newState;
};

const getAllBlockIDs = function() {
	const puzzleBlocks = RuntimeTrainerData.getPuzzleBlocks();
	return puzzleBlocks.map(b => b.id);
};

module.exports = {
	isConsideredNew,
	getAllTypeIDs,
	getAllBlockIDs,
	getCelestialHashFromID: LabUtil.getCelestialHashFromID,
	getActiveTypeIDs: LabUtil.getActiveTypeIDs,
	getTypeNameFromID: LabUtil.getTypeNameFromID,
	getCelestialFromID: LabUtil.getCelestialFromID,
	getAllTypes,
	getCelestialHashes: LabUtil.getCelestialHashes,
	getCelestialFromHash,
	unlockOnLeveling,
};
